import React from "react";
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const internetegress = require("../../../assets/icons-pack/5.3 Elastic IP/ic_01_internetegress.svg");
const flexible = require("../../../assets/icons-pack/5.3 Elastic IP/ic_02_flexible.svg");
const immediatelyuse = require("../../../assets/icons-pack/5.3 Elastic IP/ic_03_immediatelyuse.svg");
const reliablesecurestorage = require("../../../assets/icons-pack/4.1 Elastic Volume Services/ic_01_reliablesecurestorage.svg");

const ElasticIP = () => {
    const heading = `ELASTIC IP`;
    const details = `Access your cloud using static public IP addresses and scalable bandwidths`;

    const overview = [
        `An Elastic IP address is a static, public IPv4 address designed for a dynamic cloud computing. You can associate an Elastic IP address with any instance or network interface for any VPC in your account.`
    ];

    const advantages = [
        [
            `Internet Egress`,
            `EIPs serve as egress filters for cloud resources to access the Internet and can be flexibly associated with or disassociated from various resources to meet service requirements.`,
            internetegress
        ],
        [
            `Flexible`,
            `An EIP can be flexibly associated with or disassociated from an ECS, or any other node/appliance.`,
            flexible
        ],
        [
            `Immediate Use`,
            `EIP association, disassociation, and bandwidth adjustment takes effect immediately.`,
            immediatelyuse
        ],
        [
            `Reliable`,
            `EIPs can be dynamically bound and unbound from VPC ECS instances. This, in combination with the ECS snapshot function, provides high service system reliability.`,
            reliablesecurestorage
        ]
    ];

    const functions = [
        [`Flexible Billing`, [`EIPs are available on a pay-per-use (bandwidth usage or amount of traffic is billed) and yearly/monthly basis.`]],
        [`Customizable`, [`You can easily unbind an EIP from a cloud resource and bind it to another cloud resource. This allows you to use the EIP quota to meet changing service requirements.`]],
        [`High Availability`, [`Based on its highly available underlying architecture, this EIP prevents SPOF and supports cross-zone disaster tolerance.`]]
    ]
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-network"/>
            <SubNav overview={overview} advantages={advantages} functions={functions}/>
            <Footer />
        </div>
    );
};

export default ElasticIP;
